import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _, { chain, partial, split, isEmpty } from 'lodash';

import {
    DEFAULT_SORT,
    CASHBACK_SORT,
    NOM_SORT,
    LESPLUSPOPULAIRES_SORT,
    NOUVEAUTES_SORT,
    NBCOUPON_SORT,
    CASHBACK_OFFLINE_SORT,
    CASHBACK_EBON_SORT
} from '../../../../services/directory/constants';
import { PAGE_DIRECTORY } from '../../../../services/filter/constants';

import {
    sortPartnerOnName,
    sortPartnerOnOrder,
    sortPartnerOnCreationDate,
    sortPartnerOnCashback,
    sortPartnerOnCashbackOffline,
    sortPartnerOnCashbackEbon,
    sortPartnerOnNbCoupon,
    clearSort
} from '../../../../services/filter/actions';

const SelectTriCashback = ({ value, onChange, i18n, isOffline, isEbon }) => {
    return (
        // aria-label : le <label> associé est masqué en mobile (hidden-mobonly
        // = display none), le select doit garder un nom accessible (RGAA 11.1)
        <select id="annuaire-tri" onChange={onChange} value={value} aria-label={i18n.SORT_BY}>
            <option value={LESPLUSPOPULAIRES_SORT.id}>{LESPLUSPOPULAIRES_SORT.name}</option>
            {isOffline ? (
                <option value={CASHBACK_OFFLINE_SORT.id}>{i18n.SORT_BY_CASHBACK}</option>
            ) : isEbon ? (
                <option value={CASHBACK_EBON_SORT.id}>{i18n.SORT_BY_CASHBACK}</option>
            ) : (
                <option value={CASHBACK_SORT.id}>{i18n.SORT_BY_CASHBACK}</option>
            )}
            <option value={NOM_SORT.id}>{i18n.SORT_BY_NAME}</option>
            <option value={NOUVEAUTES_SORT.id}>{i18n.SORT_BY_NEW}</option>
        </select>
    );
};

const SelectTriCodepromo = ({ sorter, onChange, i18n }) => {
    return (
        <select
            id="annuaire-tri-codepromo"
            onChange={onChange}
            value={sorter}
            aria-label={i18n.SORT_BY}>
            <option value={NBCOUPON_SORT.id}>{DEFAULT_SORT.name}</option>
            <option value={LESPLUSPOPULAIRES_SORT.id}>{i18n.SORT_BY_MOST_POPULAR}</option>
            <option value={NOUVEAUTES_SORT.id}>{i18n.SORT_BY_NEW}</option>
        </select>
    );
};

class SortSelectComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { sort: 2 };
    }

    componentDidMount() {
        const { location } = this.props;

        if (location.search) {
            const params = this.getUrlParam();
            this.setState({ sort: Number(params.sort) });
            this.applySort(Number(params.sort));
        }
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (location.search !== prevProps.location.search) {
            const params = this.getUrlParam();
            this.setState({ sort: Number(params.sort) });
            this.applySort(Number(params.sort));
        }
    }

    applySort(value) {
        switch (value) {
            case NOM_SORT.id:
                this.props.sortPartnerOnName(PAGE_DIRECTORY);
                break;
            case LESPLUSPOPULAIRES_SORT.id:
                this.props.sortPartnerOnOrder(PAGE_DIRECTORY);
                break;
            case NOUVEAUTES_SORT.id:
                this.props.sortPartnerOnCreationDate(PAGE_DIRECTORY);
                break;
            case CASHBACK_SORT.id:
                this.props.sortPartnerOnCashback(PAGE_DIRECTORY);
                break;
            case CASHBACK_OFFLINE_SORT.id:
                this.props.sortPartnerOnCashbackOffline(PAGE_DIRECTORY);
                break;
            case CASHBACK_EBON_SORT.id:
                this.props.sortPartnerOnCashbackEbon(PAGE_DIRECTORY);
                break;
            case NBCOUPON_SORT.id:
                this.props.sortPartnerOnNbCoupon(PAGE_DIRECTORY);
                break;
            case DEFAULT_SORT.id:
                this.props.sortPartnerOnOrder(PAGE_DIRECTORY);
                break;
            default:
                this.props.clearSort(PAGE_DIRECTORY);
                break;
        }
    }

    getUrlParam() {
        const { location } = this.props;

        const params =
            location.search &&
            chain(location.search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();
        return params;
    }

    onChangeSort = e => {
        const { history } = this.props;
        // on change l'url pour qu'elle matche avec le choix du tri
        if (!isEmpty(e.target.value)) {
            this.setState({ sort: Number(e.target.value) });
            history.push(`?sort=${e.target.value}`);
        }
    };

    render() {
        const { i18n, isCodePromo, isOffline, isEbon } = this.props;

        const Select = isCodePromo ? SelectTriCodepromo : SelectTriCashback;

        return (
            <div id="tri-container" className="flex-container-h flex-center-alt">
                <label htmlFor="annuaire-tri" className="hidden-mobonly">
                    {i18n.SORT_BY}
                </label>
                <div className="tri-select select">
                    <Select
                        value={this.state.sort}
                        onChange={this.onChangeSort}
                        i18n={i18n}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                </div>
            </div>
        );
    }
}

SortSelectComponent.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY
    };
};

const mapDispatchToProps = {
    sortPartnerOnName,
    sortPartnerOnOrder,
    sortPartnerOnCreationDate,
    sortPartnerOnCashback,
    sortPartnerOnCashbackOffline,
    sortPartnerOnCashbackEbon,
    sortPartnerOnNbCoupon,
    clearSort
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SortSelectComponent));



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/SortSelectComponent.js